import useLotComparisonStagesData from './use-lot-comparison-stages-data'

export { useLotComparisonStagesData }

export default useLotComparisonStagesData
